import Vue from 'vue';
import Store from '@/store/store';
import Router from 'vue-router';
import VueMeta from 'vue-meta';
import Home from '@/views/Home.vue';
import Checkout from '@/components/checkout/Checkout.vue';
import MainPage from '@/components/homepage/MainPage.vue';
import Login from '@/views/Login.vue';
import AccountDetails from '@/components/account/AccountDetails.vue';
import Err5xx from '@/views/Error5xx.vue';
import Err429 from '@/views/Error429.vue';
import UnderMaintenance from '@/views/UnderMaintenance.vue';
import PageNotFound from '@/views/Notfound.vue';
import VueAnalytics from 'vue-analytics';
import Config from '@/app-configs';

Vue.use(Router);
Vue.use(VueMeta);

// Protected routes should be always on the children of first object
const allRoutes = [
  {
    path: '/',
    component: Home,
    children: [
      {
        path: '',
        component: MainPage,
      },
      {
        path: 'about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
      },

      {
        path: 'search',
        component: () => import('@/views/SearchView.vue'),
      },
      {
        path: 'faqs',
        name: 'faqs',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/FAQs.vue'),
      },
      {
        path: 'contact',
        name: 'contact',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/Contact.vue'),
      },
      {
        path: 'account',
        name: 'account',
        component: AccountDetails,
        meta: {
          requiresAuth: true,
          featureFlag: 'customer-acounts-enabled'
        }
      },
      {
        path: 'checkout',
        component: Checkout,
        meta: {
          requiresAuth: true,
          featureFlag: 'checkout-enabled'
        }
      },
      {
        path: 'orders',
        component: () => import('@/views/OrderView.vue'),
        meta: {
          requiresAuth: true,
          featureFlag: 'orders-section-enabled'
        },
      },
      {
        path: 'orders/:id',
        component: () => import('@/components/orders/SingleOrderDetail.vue'),
        meta: {
          requiresAuth: true,
          featureFlag: 'orders-section-enabled'
        },
        props: true,
      },
      {
        path: 'privacy-policy',
        name: 'privacy-pol',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/PrivacyPol.vue'),
      },
      {
        path: 'terms-conditions',
        name: 'terms-conds',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/TermsConditions.vue'),
      },
      {
        path: 'products/:productId',
        component: () => import('@/views/ProductDetail.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/payment-process/:checkoutId',
    component: () => import('@/views/PaymentProcess.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      featureFlag: 'checkout-enabled'
    }
  },
  {
    path: '/order-confirmation/:checkoutSessionId',
    component: () => import('@/views/OrderConfirmation.vue'),
    meta: {
      requiresAuth: true,
      featureFlag: 'checkout-enabled'
    },
    props: true,
  },
  {
    path: '/email-confirmation/:token',
    props: true,
    component: () => import('@/views/EmailConfirmation.vue'),
    meta: {
      featureFlag: 'customer-acounts-enabled'
    }
  },
  {
    path: '/password-reset/:token',
    props: true,
    component: () => import('@/views/PasswordConfirmation.vue'),
    meta: {
      featureFlag: 'customer-acounts-enabled'
    }
  },
  {
    path: '/login',
    component: Login,
    meta: {
      featureFlag: 'customer-acounts-enabled'
    }
  },
  {
    path: '/err-5xx',
    name: 'Err5xx',
    component: Err5xx
  },
  {
    path: '/err-429',
    name: 'Err429',
    component: Err429
  },
  {
    path: '/under-maintenance',
    name: 'UnderMaintenance',
    component: UnderMaintenance
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
  },
];

function filterRoutesEnabled(routes) {
  const routesEnabled = [];

  // Filter children protected routes
  const protectedRoutes = routes[0];
  const children = [];

  // One by one filter children protected routes
  for (let index = 0; index < protectedRoutes.children.length; index++) {
    const route = protectedRoutes.children[index];

    // If route has no feature flag associated push it to array, otherwise check if feature flag is enabled
    if(!route.meta || route.meta.featureFlag == undefined){
      children.push(_.cloneDeep(route));
    }
    else {
      const isEnabled = Store.getters['featureFlagStore/isEnabled'](route.meta.featureFlag);
      if(isEnabled) {
        // delete route.meta.featureFlag;
        children.push(_.cloneDeep(route));
      }
    }
  }

  // Overwrites children protected routes, and push protected routes to filtered array
  protectedRoutes.children = _.cloneDeep(children);
  routesEnabled.push(_.cloneDeep(protectedRoutes));
  console.log(children);

  /** Now filter all the remaining routes **/ 
  for (let index = 1; index < routes.length; index++) {
    const route = routes[index];

    // If route has no feature flag associated push it to array, otherwise check if feature flag is enabled
    if(!route.meta || route.meta.featureFlag == undefined){
      routesEnabled.push(_.cloneDeep(route));
    }
    else {
      const isEnabled = Store.getters['featureFlagStore/isEnabled'](route.meta.featureFlag);
      if(isEnabled) {
        // delete route.meta.featureFlag;
        children.push(_.cloneDeep(route));
      }
    }
  }

  return routesEnabled;
}

function handleBackendError(to, next) {
  if(!Store.getters['backendStore/isBackendAvailable']) {
    // While this getter responds with false, user will redirected to error page
    if (to.fullPath !== '/err-5xx') next({path: '/err-5xx'});
  }
  else if(Store.getters['backendStore/tooManyRequestsErr']) {
    // While this getter responds with true, user will redirected to 429 error page
    if (to.fullPath !== '/err-429') next({path:'/err-429'});
  }
  else if(!Store.getters['backendStore/isSiteEnabled']) {
    // While this getter responds with false, user will redirected to under maintenance error page
    if (to.fullPath !== '/under-maintenance') next({path: '/under-maintenance'});
  }
  else if (
    to.fullPath === '/err-5xx'
    || to.fullPath === '/err-429'
    || to.fullPath === '/under-maintenance'
  ){
    // After reload, if backend is available(again) or user unbanned this will kick out user from error page(s)
    next('/');
  }
}

function handleAuth(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Store.dispatch('authStore/checkSessionValidity')
      .then(isSessionValid => {
        if (isSessionValid) {
          next('/');
        } else {
          /*
            This will display a modal for session expired
            Modal itself will manage if user want to re-login
            And next() will redirect to prev path
          */
          Store.commit('shippingStore/resetAddresses');
          Store.commit('cartStore/resetOrders');
          Store.commit('authStore/logoutUser');
          Store.commit('authStore/setShowSessionExp', true);
          next({
            path: '/login',
            query: {
              previousPath: from.fullPath
            }
          });
        }
      })
      .catch(error => {
        console.log('A fatal error has ocurred', error);
        next('/'); // Redirects in case of fatal error
      });
  }
  else if (to.fullPath === '/login') {
    // Setting previous path here so that it can be rerouted to old url that was open before login
    next({
      path: '/login',
      query: {
        previousPath: from.fullPath
      }
    });
  }
}

// Creates an instance of router and export it for main.js file
export function createRouter() {
  // Get the routes that will be enabled
  const routes = filterRoutesEnabled(allRoutes);

  const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: routes,
  });

  /*
    Auth guard that prevents:
    - The page from going forward if the user is not authorized
    - The page from going forward if BackEnd is not available
    - The page from going forward if BackEnd doesnt gives csrf token
  */
  router.beforeEach((to, from, next) => {
    try {
      // 1. Verify and handle backend errors
      handleBackendError(to, next);

      // 2. Verify and handle authentication & permissions
      handleAuth(to, from, next);

      // 3. If everything ok or there is nothing to verify, just continue
      next();
    } catch (error) {
      console.error('Fatal error in navigation guard:', error);
      next('/'); // Redirects to root in case of error
    }
  });

  // Setup analytics
  Vue.use(VueAnalytics, {
    id: Config.analyticsId,
    router
  });

  // Return the created Router instance
  return router;
};
